import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fart fetish",
  "description": "",
  "published": "2008-05-11T00:00:00.000Z",
  "redirect_from": ["/blog/fart-fetish/swizec/114"],
  "categories": "intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Fart fetishism is very close to fecophilia if you ask me - some people have both or either. As I've had the pleasure(?) of finding out I have neither, or at least I don't have a fart fetish. Yes it's kind of an interesting thing to try, but definitely not arousing in any way ...`}</p>
    <p>{`Uhm ... yes, all things need to be tried out at least once, but only some things need to be done more than once. On top of that I don't really have much to say at this time ... this could be a nice essay-ish lengthy write up, but somehow my mind doesn't feel like thinking. More tea is required methinks.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      